







import Vue, { PropType } from 'vue';
import MallOverviewDetails from './MallOverviewDetails.vue';
import MallOverviewDirectory from './MallOverviewDirectory.vue';
import { IMall } from '@/Store';

export default Vue.extend({
  name: 'Overview',
  props: {
    details: Object as PropType<IMall>,
  },
  components: {
    MallOverviewDetails,
    MallOverviewDirectory,
  },
});
